import {createHelpers} from 'vuex-map-fields';
import {errorOutput} from "../../helpers/errorOutput";
import {__t} from "../../helpers/translate";
import {PromiseWorker} from "../../helpers/promiseWorker";
import executePromises from "../../helpers/executePromises.js";
import {setStatesLoadingList} from "../../helpers/setStatesLoadingList";
import {useToast} from 'vue-toastification';
import toast_not_select_locations from "../../components/toast/ToastNotSelectLocations.vue";

const toast = useToast();
const content = {
    component: toast_not_select_locations,
    props: {
        closeToast: (toastId) => {
            toast.dismiss(toastId);
        }
    },
}
const options = {
    toastClassName: 'toast_no_locations_selected_custom_wrap',
    debug: true,
    icon: false,
    closeOnClick: false,
    hideProgressBar: true,
    closeButton: false,
    timeout: 0,
}


const {getOrdersField, updateOrdersField} = createHelpers({
    getterType: 'getOrdersField',
    mutationType: 'updateOrdersField',
});

const state = {
    ordersNewList: [],
    ordersReadyList: [],
    ordersInProgressList: [],
    errorMessageOrder: '',
    activeItemMenuOrders: null,
    activeItemMenuOrdersDelivery: null,
    activeOrderFullInfo: null,
    activeOrderLogs: null,
    countOrders: 0,
    activeOrderPosState: null,
    activeOrderStates: null,
    posRestaurantsList: [],
    selectLocationsProducts: [],
    newOrderId: null,
    searchProductsMenuStopList: [],
    stopListProductsFilter: [],
    isSendManualPos: false,
    ordersPooling: {},
}
const actions = {

    GET_ORDERS_POOLING({commit}, params) {
        $api.get('/internal/order/pooling')
            .then(resp => {
                if (resp.data) {
                    params.resp = resp.data;
                    commit('getOrdersPooling', params);
                } else {
                    state.errorMessageOrder = 'Do not get orders';
                    console.error(resp);
                    if(resp && resp.data
                        && resp.data.message === "No selected locations found for orders pooling") {
                        toast(content, options);
                    }else {
                        errorOutput(__t('O.ERROR_RECEIVING_ORDERS'), state.errorMessageOrder, params.actionName);
                    }

                    if (params.eventSend) {
                        EventBus.$emit('get_orders_pooling');
                    }
                }
            })
            .catch(err => {
                console.error(err);
                if(err.response && err.response.data
                    && err.response.data.message === "No selected locations found for orders pooling") {
                        toast(content, options);
                    } else {
                        errorOutput(__t('O.ERROR_RECEIVING_ORDERS'), err, params.actionName);
                    }
                    if (params.eventSend) {
                        EventBus.$emit('get_orders_pooling');
                    }
                }
            )
    },

    CLICK_MENU_ITEM_MENU_ORDERS({commit}, params) {
        commit('clickItemMenuOrders', params);
    },

    GET_ORDER_FULL_INFO({commit}, params) {
        if (state.activeItemMenuOrders && state.activeItemMenuOrders.id) {
            $api.get('/internal/order/' + state.activeItemMenuOrders.id.toString())
                .then(resp => {
                    if (resp.data) {
                        params.resp = resp.data;
                        commit('getOrderFullInfo', params);
                    } else {
                        state.errorMessageOrder = 'Do not get order full info';
                        errorOutput(__t('O.ERROR_RECEIVING_ORDER_INFORMATION'), state.errorMessageOrder, params.actionName);
                    }
                })
                .catch(err => {
                        errorOutput(__t('O.ERROR_RECEIVING_ORDER_INFORMATION'), err, params.actionName);
                        if (params.eventSend) {
                            EventBus.$emit('get_order_full_info');
                        }
                    }
                )
        } else {
            if (params.eventSend) {
                EventBus.$emit('get_order_full_info');
            }
        }
    },

    GET_ORDER_LOGS({commit}, params) {
        if (state.activeItemMenuOrders && state.activeItemMenuOrders.id) {
            $api.get('/internal/order/' + state.activeItemMenuOrders.id.toString() + '/logs')
                .then(resp => {
                    if (resp.data) {
                        params.resp = resp.data;
                        commit('getOrderLogs', params);
                    } else {
                        state.errorMessageOrder = 'Do not get order logs';
                        //errorOutput(__t('O.ERROR_RECEIVING_ORDER_POS_INFORMATION'), state.errorMessageOrder);
                    }
                })
                .catch(err => {
                        //errorOutput(__t('O.ERROR_RECEIVING_ORDER_POS_INFORMATION'), err);
                        if (params.eventSend) {
                            EventBus.$emit('get_order_logs');
                        }
                    }
                )
        } else {
            if (params.eventSend) {
                EventBus.$emit('get_order_logs');
            }
        }
    },

    GET_ORDER_POS_STATE({commit}, params) {
        if (state.activeItemMenuOrders && state.activeItemMenuOrders.id) {
            $api.get('/internal/order/' + state.activeItemMenuOrders.id.toString() + '/pos_state')
                .then(resp => {
                    if (resp.data) {
                        params.resp = resp.data;
                        commit('getOrderPosState', params);
                    } else {
                        state.errorMessageOrder = 'Do not get pos state';
                        //errorOutput(__t('O.ERROR_RECEIVING_ORDER_POS_INFORMATION'), state.errorMessageOrder);
                        if (params.eventSend) {
                            EventBus.$emit('get_order_pos_state');
                        }
                    }
                })
                .catch(err => {
                        //errorOutput(__t('O.ERROR_RECEIVING_ORDER_POS_INFORMATION'), err);
                        if (params.eventSend) {
                            EventBus.$emit('get_order_pos_state');
                        }
                    }
                )
        } else {
            if (params.eventSend) {
                EventBus.$emit('get_order_pos_state');
            }
        }
    },

    GET_ORDER_STATES({commit}, params) {
        if (state.activeItemMenuOrders && state.activeItemMenuOrders.id) {
            $api.get('/internal/order/' + state.activeItemMenuOrders.id.toString() + '/states')
                .then(resp => {
                    if (resp.data) {
                        params.resp = resp.data;
                        commit('getOrderStates', params);
                    } else {
                        state.errorMessageOrder = 'Do not get order states';
                        errorOutput(__t('O.ERROR_RECEIVING_ORDER_STATE_INFORMATION'), state.errorMessageOrder);
                        if (params.eventSend) {
                            EventBus.$emit('get_order_states');
                        }
                    }
                })
                .catch(err => {
                        errorOutput(__t('O.ERROR_RECEIVING_ORDER_STATE_INFORMATION'), err);
                        if (params.eventSend) {
                            EventBus.$emit('get_order_states');
                        }
                    }
                )
        } else {
            if (params.eventSend) {
                EventBus.$emit('get_order_states');
            }
        }
    },

    CHANGE_ORDER_STATE({commit}, params) {
        let api = null;
        if (params.timeSelect !== null) {
            const prepTime = {prep_time: params.timeSelect};
            api = $api.patch('/internal/order/' + state.activeItemMenuOrders.id.toString() + '/' + params.itemButton.action, prepTime);
        } else {
            api = $api.patch('/internal/order/' + state.activeItemMenuOrders.id.toString() + '/' + params.itemButton.action)
        }
        api
            .then(resp => {
                if (resp.data) {
                    params.resp = resp.data;
                    commit('changeOrderState', params);
                } else {
                    state.errorMessageOrder = 'Do not change order states';
                    errorOutput(__t('O.FAIL_TO_CHANGE_ORDER_STATUS'), state.errorMessageOrder);
                    if (params.eventSend) {
                        EventBus.$emit('change_order_state');
                    }
                }
            })
            .catch(err => {
                    errorOutput(__t('O.FAIL_TO_CHANGE_ORDER_STATUS'), err);
                    if (params.eventSend) {
                        EventBus.$emit('change_order_state');
                    }
                }
            )
    },
    POS_RESTAURANTS_LIST({commit}) {
        $api.get('/internal/pos/restaurants/with_location')
            .then(({data}) => {
                if (data.status && data.status !== 'operation_fail') {
                    commit('posRestaurantsList', data);
                } else {
                    errorOutput(__t('O.FAILED_TO_GET_INFORMATION'), data);
                    EventBus.$emit('load_pos_restaurants_list');
                }
            })
            .catch(err => {
                    errorOutput(__t('O.FAILED_TO_GET_INFORMATION'), err);
                    EventBus.$emit('load_pos_restaurants_list');
                }
            )
    },
    SET_ACTIVE_NEW_ORDER_ID({commit}, idNewOrder) {
        commit('setActiveNewOrderId', idNewOrder);
    },
    async SEND_MANUAL_POS({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'posOrderManualSend',
                url: '/internal/order/{orderId}/send',
                paramsUrl:
                    {
                        orderId: params.orderId
                    },
                method: 'PUT',
                body: null,
            },
        )

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            params.results = results;
            const errorsList = requestsPromises.getErrorsResponses(results);
            if (errorsList.length > 0) {
                errorOutput(__t('O.FAILED_SEND_MANUAL_POS_ORDER'), JSON.stringify(errorsList), params.actionName);
                return;
            }
            commit('sendManualPos', params);
        } catch (err) {
            errorOutput(__t('O.FAILED_SEND_MANUAL_POS_ORDER'), err, params.actionName);
        }

    },
    SET_STATES_LOADING_LIST({commit}, params) {
        commit('setStatesLoadingList', params);
    },
}

const mutations = {
    updateOrdersField,
    sendManualPos(state, params) {
        //console.log(params)
        EventBus.$emit('send_manual_order_pos');
    },
    setActiveNewOrderId(state, idNewOrder) {
        state.newOrderId = idNewOrder;
    },
    getOrdersPooling(state, params) {
        if (params.resp.data && params.resp.status === 'operation_success') {
            state.ordersPooling = params.resp.data;

            if (params.resp.data.new) {
                state.ordersNewList = params.resp.data.new;
            }
            if (params.resp.data.in_progress) {
                state.ordersInProgressList = params.resp.data.in_progress;
            }
            if (params.resp.data.ready) {
                state.ordersReadyList = params.resp.data.ready;
            }
        } else {
            state.errorMessageOrder = 'Do not get orders pooling';
            if(params.resp
                && params.resp.message === "No selected locations found for orders pooling") {
                toast(content, options);
            }else {
                console.error(params.resp);
                errorOutput(__t('O.ERROR_GET_INFORMATION'), params.resp, params.actionName);
            }
        }
        if (state.activeItemMenuOrders === null || state.activeItemMenuOrders === undefined) {
            if (state.ordersNewList.length !== 0) {
                state.activeItemMenuOrders = state.ordersNewList[0];
            } else if (state.ordersInProgressList.length !== 0) {
                state.activeItemMenuOrders = state.ordersInProgressList[0];
            } else if (state.ordersReadyList.length !== 0) {
                state.activeItemMenuOrders = state.ordersReadyList[0];
            }
        }
        state.countOrders = state.ordersNewList.length + state.ordersInProgressList.length + state.ordersReadyList.length;
        let paramsMain = {
            orders: state.countOrders
        }
        $store.dispatch('user/UPDATE_MENU_MAIN_INFO', paramsMain);
        if (params.eventSend) {
            EventBus.$emit('get_orders_pooling');
        }
        if (params.newOrderIn && params.newOrderIn.id) {
            EventBus.$emit('new_order_in', params.newOrderIn);
        }
    },
    clickItemMenuOrders(state, params) {
        console.log('clickItemMenuOrders', params);
        state.activeItemMenuOrders = params.item;
        const params1 = {...params, actionName: 'getOrderFullInfo'};
        const params2 = {...params, actionName: 'getOrderLogs'};
        const params3 = {...params, actionName: 'getOrderPosState'};
        const params4 = {...params, actionName: 'getOrderState'};
        const promises = [
            $store.dispatch('orders/GET_ORDER_FULL_INFO', params1),
            $store.dispatch('orders/GET_ORDER_LOGS', params2),
            $store.dispatch('orders/GET_ORDER_POS_STATE', params3),
            $store.dispatch('orders/GET_ORDER_STATES', params4),
        ];
        Promise.all(promises)
            .catch((error) => {
                console.error(error);
                errorOutput(__t('O.ERROR_GET_INFORMATION_ORDER'), error);
            });
        console.log('clickItemMenuOrders end')
    },
    getOrderFullInfo(state, params) {
        if (params.resp.status === 'operation_success') {
            state.activeOrderFullInfo = params.resp.data;
        } else {
            errorOutput(__t('O.ERROR_GET_INFORMATION_ORDER'), params.resp.message, params.actionName);
        }
        if (params.eventSend) {
            EventBus.$emit('get_order_full_info');
        }
    },
    getOrderLogs(state, params) {
        if (params.resp.status === 'operation_success') {
            state.activeOrderLogs = params.resp.data;
        } else {
            errorOutput(__t('O.ERROR_GET_INFORMATION_LOGS'), params.resp.message, params.actionName);
        }
        if (params.eventSend) {
            EventBus.$emit('get_order_logs');
        }
    },
    getOrderPosState(state, params) {
        if (params.resp.status === 'operation_success') {
            state.activeOrderPosState = params.resp.data;
        } else {
            errorOutput(__t('O.ERROR_GET_INFORMATION_POS'), params.resp.message, params.actionName);
            if (params.eventSend) {
                EventBus.$emit('get_order_pos_state');
            }
        }
        if (params.eventSend) {
            EventBus.$emit('get_order_pos_state');
        }
    },
    getOrderStates(state, params) {
        if (params.resp.status === 'operation_success') {
            state.activeOrderStates = params.resp.data;
        } else {
            errorOutput(__t('O.ERROR_GET_INFORMATION_ORDER_STATE'), params.resp.message, params.actionName);
        }
        if (params.eventSend) {
            EventBus.$emit('get_order_states');
        }
    },
    changeOrderState(state, params) {
        if (params.resp.status === 'operation_fail') {
            errorOutput(__t('O.ERROR_CHANGE_ORDER_STATE'), params.resp.message, params.actionName);
        }
        EventBus.$emit('change_order_state', params.itemButton);
    },
    posRestaurantsList(state, data) {
        if (data.data) {
            state.posRestaurantsList = data.data;
            let params = {
                stop_list: state.posRestaurantsList.length,
            }
            $store.dispatch('user/UPDATE_MENU_MAIN_INFO', params);
        }
        EventBus.$emit('load_pos_restaurants_list');
    },
    setStatesLoadingList(state, params) {
        setStatesLoadingList(state, params);
    },

}

const getters = {
    getOrdersField,
    getNewOrderId(state) {
        return state.newOrderId;
    },
    getOrdersNewList(state) {
        return state.ordersNewList;
    },
    getOrdersInProgressList(state) {
        return state.ordersInProgressList;
    },
    getOrdersReadyList(state) {
        return state.ordersReadyList;
    },
    getActiveItemMenuOrders(state) {
        return state.activeItemMenuOrders;
    },
    getActiveOrderFullInfo(state) {
        return state.activeOrderFullInfo;
    },
    getActiveOrderLogs(state) {
        return state.activeOrderLogs;
    },
    getCountOrders(state) {
        return state.countOrders;
    },
    getActiveOrderStates(state) {
        return state.activeOrderStates;
    },
    getPosRestaurantsList(state) {
        return state.posRestaurantsList;
    },
    getSelectLocationsProducts(state) {
        return state.selectLocationsProducts;
    },
}


export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
